import { replace } from 'react-router-redux'; 
import { Auth,Cache,API } from 'aws-amplify'; 
 
let apiName = 'SmartDeviceAPI'; 
let path = '/registration'; 
let usersPath ='/users';
 
const startRequest = category => ({ 
    type: 'START_BIND_REQUEST', 
    payload: { category } 
}); 
 
const receiveData = (category, error, response) => ({ 
    type: 'RECEIVE_BIND_DATA', 
    payload: { category, error, response } 
}); 
 
const finishRequest = category => ({ 
    type: 'FINISH_BIND_REQUEST', 
    payload: { category } 
}); 
 
 
const startPost = (category, commands) => ({ 
    type: 'START_BIND_POST', 
    payload: { category, commands } 
}); 
 
const finishPost = (ranking, item,deleteFlg, uploadCheck, err) => ({ 
    type: 'FINISH_BIND_POST', 
    payload: { ranking, item, deleteFlg,uploadCheck, err } 
}); 
 
export const fetchRanking = categoryId => { 
    return async (dispatch, getState) => { 
        const category = 'registration'; 
         
        let _user = undefined; 
        Auth.currentAuthenticatedUser().then(user => { 
            _user = user.id; 
            if (_user === undefined) { 
            _user = user.username; 
            } 
            //let user = Auth.user.id; 
            /*if (_user === undefined) { 
                Cache.getItem('federatedInfo').then(federatedInfo => { 
                     const { token } = federatedInfo; 
                     console.log(token); 
                }); 
                _user = Auth.user.username; 
            }*/ 
            console.log(Cache.getAllKeys()); 
            dispatch(startRequest(category)); 
     
            const myInit = { 
                response: true, // OPTIONAL (return entire response object instead of response.data) 
            }; 
     
            API.get(apiName, path + '?userid=' + _user, myInit).then(response => { 
                const data = response.data; 
                dispatch(receiveData(category, null, data)); 
            }).catch(err => { 
                console.log(err.response) 
                dispatch(receiveData(category, err)); 
            }); 
            dispatch(finishRequest(category)); 
         
        }).catch(err => { 
            console.log(err); 
            dispatch(receiveData(category, err)); 
        }); 
         
    }; 
}; 
 
export const postData = (ranking, item, deleteFlg, uploadCheck) => { 
    return async (dispatch, getState) => {  
        if (typeof item.devicename === 'undefined') { 
            dispatch(replace('/')); 
            return; 
        } 
        const category = 'registration'; 
         
        let _user = undefined; 
        Auth.currentAuthenticatedUser().then(user => { 
            _user = user.id; 
            if (_user === undefined) { 
            _user = user.username; 
            } 
             
            dispatch(startPost(category, item.devicename)); 
            console.log(_user); 
            let _devices = undefined; 
            if (item !== undefined) { 
                _devices = [{ 
                        serialnumber: item.serialnumber, 
                        devicename: item.devicename, 
                        comment: item.comment, 
                        displayname: item.displayname 
                }]; 
            } 
             
            const myInit = { 
                body: {  
                    userid: _user, 
                    uploadCheck: uploadCheck, 
                    deleteTheta: deleteFlg, 
                    devices: _devices  
                }, 
                headers: {'content-type': 'application/json'} 
            }; 
             
            API.post(apiName, path, myInit).then(response => { 
                dispatch(finishPost(ranking, item, deleteFlg, uploadCheck, null)); 
            }).catch(err => { 
                console.log(err.response) 
                dispatch(finishPost(ranking, item, deleteFlg, uploadCheck, err)); 
            }); 
             
        }).catch(err => { 
            console.log(err); 
        }); 
         
        }; 
}; 
 
 
const category = 'postData'; 
let shootingPath = '/execute'; 
 
const startShootingRequest = category => ({ 
    type: 'START_SHOOTING_REQUEST', 
    payload: { category } 
}); 
 
const receiveShootingData = (category, error, response) => ({ 
    type: 'RECEIVE_SHOOTING_DATA', 
    payload: { category, error, response } 
}); 
 
const finishShootingRequest = category => ({ 
    type: 'FINISH_SHOOTING_REQUEST', 
    payload: { category } 
}); 
 
 
const startShootingPost = (category, commands) => ({ 
    type: 'START_SHOOTING_POST', 
    payload: { category, commands } 
}); 
 
const finishShootingPost = (category, commands, err) => ({ 
    type: 'FINISH_SHOOTING_POST', 
    payload: { category, commands,err } 
}); 

const startUnsubscribeAccount = category => ({
    type: 'START_UNSUBSCRIBE_ACCOUNT',
    payload: { category }
});

const finishUnsubscribeAccount = statusCode => ({
    type: 'FINISH_UNSUBSCRIBE_ACCOUNT',
    payload: { statusCode }
});
 
export const getOptions = devicename => { 
    return async (dispatch, getState) => { 
        let _user = undefined; 
        Auth.currentAuthenticatedUser().then(user => { 
            _user = user.id; 
            if (_user === undefined) { 
            _user = user.username; 
            } 
            //let user = Auth.user.id; 
            console.log(_user); 
             
            dispatch(startShootingRequest(category)); 
            const myInit = { 
                response: true, // OPTIONAL (return entire response object instead of response.data) 
            }; 
     
            API.get(apiName, shootingPath + '?userid=' + _user + '&devicename=' + devicename, myInit).then(response => { 
                const data = response.data; 
                dispatch(receiveShootingData(category, null, data)); 
            }).catch(err => { 
                console.log(err.response) 
                dispatch(receiveShootingData(category, err)); 
            }); 
            dispatch(finishShootingRequest(category)); 
             
        }).catch(err => { 
            console.log(err); 
            dispatch(receiveShootingData(category, err)); 
        }); 
    }; 
}; 
 
export const postShootingData = (devicename, commands) => { 
    return async (dispatch, getState) => { 
        if (typeof devicename === 'undefined') { 
            dispatch(replace('/')); 
            return; 
        } 
        if (typeof commands === 'undefined') { 
            dispatch(replace('/')); 
            return; 
        } 
         
        let _user = undefined; 
        let _token = undefined; 
        Auth.currentAuthenticatedUser().then(user => { 
            _user = user.username; 
            if (_user === undefined) { 
                _user = user.id; 
            } 
 
            Auth.currentCredentials() 
              .then(credentials => { 
                dispatch(startShootingPost(category,commands)); 
                _token = credentials.data.Credentials; 
                 
                const myInit = { 
                    body: { 
                        userid: _user, 
                        credentials: _token, 
                        deviceid: devicename, 
                        commands: commands 
                    } 
                }; 
         
                API.post(apiName, shootingPath, myInit).then(response => { 
                    dispatch(finishShootingPost(category, commands, null)); 
                }).catch(err => { 
                    console.log(err.response) 
                    dispatch(finishShootingPost(category, commands, err)); 
                }); 
            }).catch(err => { 
                console.log(err); 
                dispatch(finishShootingPost(category, commands, err)); 
            }); 
     
        }).catch(err => { 
            console.log(err); 
            dispatch(finishShootingPost(category, commands, err)); 
        }); 
    }; 
}; 

export const unsubscribeAccount = statusCode => { 
    return async (dispatch, getState) => { 
        const category = 'users'; 
         
        let _user = undefined; 
        Auth.currentAuthenticatedUser().then(user => { 
            _user = user.id; 
            if (_user === undefined) { 
            _user = user.username; 
            } 
          
            Auth.currentCredentials() 
              .then(credentials => { 
                 dispatch(startUnsubscribeAccount(category)); 
                  
                 const myInit = {
                    body: {
                        userid: _user,
                        credentials: credentials
                    },
                    headers: {
                        'content-type': 'application/json'
                    },
                    response: true
                };
     
            API.post(apiName, usersPath + '/'+ _user , myInit).then(response => {
                   dispatch(finishUnsubscribeAccount(response.status));
               }).catch(err => {
                   console.log(err.response);
                   dispatch(finishUnsubscribeAccount(400));
               });
           }).catch(err => {
               console.log(err);
               dispatch(finishUnsubscribeAccount(400));
           });
   
       }).catch(err => {
           console.log(err);
           dispatch(finishUnsubscribeAccount(400));
       });
    }; 
}; 


// WEBPACK FOOTER //
// ./src/actions/ThetaBindList.js